<template>
    <div class="consent">
        <span>Durch Anklicken von "{{buttonName}}" bestätigst du deine Eingabe und stimmst unseren </span>
        <router-link :to="{ name: 'Datenschutz'}">Datenschutzbestimmungen</router-link>
        <span> sowie </span>
        <router-link :to="{ name: 'AGB'}">AGB</router-link>
        <span> zu. Du bist damit einverstanden E-Mails von {{$store.state.brandName}} zu erhalten, wenn du aktiver Kunde sind.</span>
    </div>
</template>

<script>
    export default {

        props: ['buttonName']

    }
</script>

<style lang="scss" scoped>
    @import '../styles/base';

    .consent {
        padding: 15px 0;
        span {
            color: rgba($font-color, 0.8);
        }
        a{
            color: $font-color;
        }
    }

</style>